import Text from "../Text";
import cn from "classnames";
import { getStaticImg } from "../../../utils/function";
const Card = ({
  title,
  desc,
  tail,
  img,
  verticalLayout = false,
  className,
  imgClassName = "card-container__image",
  titleClassName = "card-container__title",
  descClassName = "card-container__desc",
  tailClassName = "card-container__tail",
  innerClassName = "",
  onClick = () => {},
}) => {
  const classNames = cn("card-container", className, {
    "card-container__vertical": verticalLayout,
  });
  return (
    <div className={classNames} onClick={onClick}>
      <div className={!verticalLayout && "card-container__horizontal"}>
        <div className={imgClassName}>
          <img
            className={innerClassName}
            src={img ?? getStaticImg("/illustration/default-image.png")}
          />
        </div>

        <div className={"card-container__content-text"}>
          <Text size="medium" weight="bold" className={titleClassName}>
            {title}
          </Text>
          <Text size="small" className={descClassName}>
            {desc}
          </Text>
          <Text size="micro" weight="bold" className={tailClassName}>
            {tail}
          </Text>
        </div>
      </div>
    </div>
  );
};
export default Card;
